import { apolloClient } from "@/plugins/vue-apollo.js";

const updateFacility = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/facility/update_facility.graphql"),
      variables: variables,
      
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/facility/facility_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        // debugger
        let allFacility = store.readQuery(query);
        // debugger
        const findIndex = allFacility.getFacilities.facilities.findIndex(
          (item) => item._id === data.updateFacility._id
        );
        findIndex !== -1 &&
          allFacility.getFacilities.facilities.splice(
            findIndex,
            1,
            data.updateFacility
          );
        store.writeQuery({
          ...query,
          data: allFacility,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateFacility };
